import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Checks for buyerToken and organizerId in localStorage. Redirects to home if not authenticated.
export function useAuthGuard(language) {
    const navigate = useNavigate();
    useEffect(() => {
        const buyerToken = localStorage.getItem("buyerToken");
        const organizerId = localStorage.getItem("loggedInOrganizerId");
        if (!buyerToken || !organizerId) {
            navigate(`/${language}/login`, { replace: true });
        }
    }, [navigate]);
}
